  <label class="checkbox" [attr.for]="option.optionid">
    <span class="checkbox__input">
      <input type="checkbox" [name]="schedulequestionid" [attr.class]="schedulequestionid" [value]="option.optionid" id="{{option.optionid}}" [checked]=option.selected (change)="checkChanged($event,option)" [attr.aria-labelledby]="'label-' + option.optionid">
      <span class="checkbox__control">
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' aria-hidden="true" focusable="false">
          <path fill='none' stroke='currentColor' stroke-width='3' d='M1.73 12.91l6.37 6.37L22.79 4.59' /></svg>
      </span>
    </span>
    <span tabindex="-1" aria-hidden="true" #optionCheckhtmlspan class="radio__label" [id]="'label-' + option.optionid"></span>
  </label>